import { App, ComponentPublicInstance } from 'vue'
import { errorService } from '@/services/errorService'

/**
 * Vue plugin for global error handling
 */
export const errorHandlerPlugin = {
  install: (app: App) => {
    // Set up global error handler for Vue errors
    app.config.errorHandler = (
      err: unknown,
      instance: ComponentPublicInstance | null,
      info: string
    ) => {
      // Get component information if available
      const componentName = instance ? 
        instance.$options.name || 
        instance.$options.__file || 
        'Unknown Component' : 
        'No Component'
      
      // Handle the error through our error service
      errorService.handleError(err, {
        component: componentName,
        info,
        lifecycleHook: info,
        componentData: instance ? { ...instance.$data } : undefined
      })
      
      // Log to console in development
      if (process.env.NODE_ENV !== 'production') {
        console.error('Vue Error:', err)
        console.error(`Component: ${componentName}`)
        console.error(`Info: ${info}`)
      }
    }
    
    // Add errorService to the global properties
    app.config.globalProperties.$errorService = errorService
  }
}

// Type declaration for TypeScript
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $errorService: typeof errorService
  }
}
